import { render, staticRenderFns } from "./History.vue?vue&type=template&id=0b2aa59a&scoped=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"
import style0 from "./History.vue?vue&type=style&index=0&id=0b2aa59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2aa59a",
  null
  
)

export default component.exports